"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    console.log('Adding index to view column tables...');
    console.time('Added index to Grid view columns');
    await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW_COLUMNS, (table)=>{
        table.index([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    console.timeEnd('Added index to Grid view columns');
    console.time('Added index to Gallery view columns');
    await knex.schema.alterTable(_globals.MetaTable.GALLERY_VIEW_COLUMNS, (table)=>{
        table.index([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    console.timeEnd('Added index to Gallery view columns');
    console.time('Added index to Kanban view columns');
    await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW_COLUMNS, (table)=>{
        table.index([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    console.timeEnd('Added index to Kanban view columns');
    console.time('Added index to Form view columns');
    await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW_COLUMNS, (table)=>{
        table.index([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    console.timeEnd('Added index to Form view columns');
    console.time('Added index to Calendar view columns');
    await knex.schema.alterTable(_globals.MetaTable.CALENDAR_VIEW_COLUMNS, (table)=>{
        table.index([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    console.timeEnd('Added index to Calendar view columns');
    console.time('Added index to Map view columns');
    await knex.schema.alterTable(_globals.MetaTable.MAP_VIEW_COLUMNS, (table)=>{
        table.index([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    console.timeEnd('Added index to Map view columns');
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW_COLUMNS, (table)=>{
        table.dropIndex([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    await knex.schema.alterTable(_globals.MetaTable.GALLERY_VIEW_COLUMNS, (table)=>{
        table.dropIndex([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW_COLUMNS, (table)=>{
        table.dropIndex([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW_COLUMNS, (table)=>{
        table.dropIndex([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    await knex.schema.alterTable(_globals.MetaTable.CALENDAR_VIEW_COLUMNS, (table)=>{
        table.dropIndex([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
    await knex.schema.alterTable(_globals.MetaTable.MAP_VIEW_COLUMNS, (table)=>{
        table.dropIndex([
            'fk_view_id',
            'fk_column_id'
        ]);
    });
};
